import * as actionCreatorFactory from "typescript-fsa";

import { HttpStateError, NormalisedResult } from "@orm/models";
import * as actionTypes from "../constants";
import { VendorNormalisedEntities, PlaylistFilters } from "../models";

export type VendorResultId = NormalisedResult<number[], VendorNormalisedEntities>;
export type VendorResultString = NormalisedResult<string[], VendorNormalisedEntities>;

const actionCreator = actionCreatorFactory.default();

// Playlists index
export const requestPlaylistsIndex = actionCreator<{}>(actionTypes.PLAYLIST_INDEX_REQUEST);
export const playlistsIndexSuccess = actionCreator<VendorResultId>(
    actionTypes.PLAYLIST_INDEX_SUCCESS,
);
export const playlistsIndexFailure = actionCreator<HttpStateError>(actionTypes.PLAYLIST_INDEX_FAILURE);

// Playlists show
export const requestPlaylistsShow = actionCreator<number>(actionTypes.PLAYLIST_SHOW_REQUEST);
export const playlistsShowSuccess = actionCreator<NormalisedResult<number, VendorNormalisedEntities>>(
    actionTypes.PLAYLIST_SHOW_SUCCESS,
);
export const playlistsShowFailure = actionCreator<HttpStateError>(actionTypes.PLAYLIST_SHOW_FAILURE);

// Tracks index
export const requestTracksIndex = actionCreator<{}>(actionTypes.TRACK_INDEX_REQUEST);
export const tracksIndexSuccess = actionCreator<VendorResultString>(
    actionTypes.TRACK_INDEX_SUCCESS,
);
export const tracksIndexFailure = actionCreator<HttpStateError>(actionTypes.TRACK_INDEX_FAILURE);

export const setPlaylistFilters = actionCreator<PlaylistFilters>(actionTypes.PLAYLIST_SET_FILTERS);
